export const CONSIGNMENT_SWITCHER_TEST_ID = 'ConsignmentSwitcher';
export const CONSIGNMENT_SWITCHER_DROPDOWN_TEST_ID = 'ConsignmentSwitcherDropdown';
export const CONSIGNMENT_SWITCHER_CHEVRON_LEFT_TEST_ID = 'ConsignmentSwitcherChevronLeft';
export const CONSIGNMENT_SWITCHER_CHEVRON_RIGHT_TEST_ID = 'ConsignmentSwitcherChevronRight';
